import { defineSlotRecipe } from '@chakra-ui/react'

// Checkbox / Radio: checked state fills with the accent solid (brand.solid),
// matching Button/Input's Field Green accent. Checkbox control also gets the
// tightened radii.xs (6px) to read as a small filled square rather than the
// stock rounded default — these are fixed-size controls (16-20px), so unlike
// Input/NativeSelect/Button (field.recipe.ts, button.recipe.ts) there is no
// sm/md density height variant here; the `compact` condition only governs
// control heights on those larger controls, not on checkbox/radio hit
// targets.
//
// IMPORTANT: the checked fill is wired via `root: { colorPalette: 'brand' }`,
// NOT via a `_checked` override on control/itemControl. Chakra's stock
// checkmarkRecipe/radiomarkRecipe already paint the checked state through
// `variant.solid`'s own literal `&:is([data-state=checked], ...)` selector
// (`bg: colorPalette.solid`), which resolves through the ambient
// `colorPalette` CSS custom property cascading down from the root slot. An
// earlier version of this recipe added a competing `control._checked` rule
// with a literal `bg: 'brand.solid'` — Chakra's `_checked` condition compiles
// to a *different* selector string (`&:is(:checked, [data-checked],
// [aria-checked=true], [data-state=checked])`) than the stock rule's literal
// `&:is([data-state=checked], [data-state=indeterminate])`. Both rules have
// equal CSS specificity (each keyed on the `[data-state=checked]` attribute)
// and both survive into the compiled output as sibling rules (verified via
// `system.getSlotRecipeFn('checkbox')({})` — see task-3-report.md fix
// addendum), so the stock rule — emitted after ours — won the cascade tie and
// the accent fill never rendered. Defaulting `colorPalette` on the root slot
// instead lets the *existing* stock rule do the painting, with no competing
// selector and no cascade fight.
export const checkboxSlotRecipe = defineSlotRecipe({
  slots: ['root', 'label', 'control', 'indicator'],
  base: {
    root: { colorPalette: 'brand' },
    control: { borderRadius: 'xs' },
  },
})

export const radioSlotRecipe = defineSlotRecipe({
  slots: ['root', 'label', 'item', 'itemText', 'itemControl', 'indicator'],
  base: {
    root: { colorPalette: 'brand' },
  },
})
